import '../../styles/pages/contacts.scss';

const tabs = document.querySelector(".contacts__tabs");
const tabButton = document.querySelectorAll(".contacts__tabs-link");
const contents = document.querySelectorAll(".contacts__panel");

tabs.onclick = e => {
    e.preventDefault();
    const id = e.target.dataset.id;
    if (id) {
        tabButton.forEach(btn => {
            btn.classList.remove("active");
        });

        e.target.classList.add("active");

        contents.forEach(content => {
            content.classList.remove("active");
        });

        const element = document.getElementById(id);
        element.classList.add("active");
    }
}

document.querySelector('#message').addEventListener('input', function () {
    document.querySelector('.form__count-value').innerHTML = this.value.length;
});
